export const survey_config_base = {
  progressBarShowPageTitles: false,
  showQuestionNumbers: 'off',
  showPrevButton: false,
  showNavigationButtons: 'none',
  navigateToUrl: '', // Using JS in the RiseSurvey.tsx to navigate via React Router
  showCompletedPage: false,
  showTitle: false,
  questionTitlePattern: 'numTitle', //hides asterisk on required questions
  // SurveyJS defaults to focusing the first interactive element on each
  // page, which calls scrollIntoView() under the hood and pushes the
  // RISE header + progress bar off-screen on every page change. Disable
  // it — the user can still tab/click to focus when they want to.
  focusFirstQuestionAutomatic: false,
};
